import React, { Component } from 'react'
import NumericInput from 'react-numeric-input'
import ConvertQuantity from './ConvertQuantity'


class QtyInputPlusMinus extends Component {

  state = {
    disabled: false,
    readOnly: false,
    subValue: this.props.defaultValue,
  };

  onChange = (subValue) => {

    if (subValue === 0) {
      this.setState({ value: 0, subValue: 0 }, () => {
        this.props.onChange(0, 0)
      })
    } else {

      const { min, max, disabled, measurementType, subMeasurementType, conversionUnit } = this.props;

      let val = 0;
      let subVal = 0;

      if (conversionUnit) {

        val = ConvertQuantity(subValue, conversionUnit, 3, 1);

        subVal = subValue

      } else {

        val = subValue

        subVal = subValue

      }

      this.setState({ value: val, subValue: subVal }, () => {
        this.props.onChange(val, subVal)
      })
    }

  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.defualtValue !== undefined && nextProps.defualtValue !== this.state.subValue) {
      this.onChange(nextProps.defualtValue)
    }

  }

  render() {
    const { value, subValue } = this.state;

    const { min, max, disabled } = this.props;
    return (
      <div className={value != undefined && (value > 0 ? "qty-increse" : value < 0 ? "qty-decrese" : "")}>
        <NumericInput
          mobile
          strict

          // className="text-input ltr"
          min={min}
          max={max}
          value={subValue}
          onChange={this.onChange}
          disabled={disabled}
        />
      </div>
    );
  }
}
export default QtyInputPlusMinus;
